import { render, staticRenderFns } from "./PortfolioSingle.vue?vue&type=template&id=27abc784&"
import script from "./PortfolioSingle.vue?vue&type=script&lang=js&"
export * from "./PortfolioSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports